import React, { useEffect, useState } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import ApiRequest from "../Common/restservice";
import { errorToast } from "../Common/showtoast";
import { Link, useLocation, useNavigate } from "react-router-dom";
import emptycart from "../Assets/Images/cart.png";
import IndividualGrid from "../Components/IndividualGrid";
import moment from "moment";
function AllFreelancers() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const searchtext = params.get("txt");
  const [freeLancers, setFreeLancers] = useState([]);
  const sub_category = params.get("sub_category");
  const _location = params.get("location");
  const pageno = params.get("pageno") || 1;
  const [selectSubCategories, setselectSubCategories] = useState("");
  const [location, setLocation] = useState("");
  // const [pageno, setpageno] = useState(1);
  const [sortBy, setSortBy] = useState("latest");
  // const [minPrice, setMinPrice] = useState(0);
  // const [maxPrice, setMaxPrice] = useState(1000);
  const [selectCategories, setselectCategories] = useState("freelancer");
  const [searchText, setsearchText] = useState("");
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [stateObj, setStateObj] = useState({});
  useEffect(() => {
    if (localStorage.getItem("token")) GetMyProfile();
  }, []);
  const GetMyProfile = async (e) => {
    let res = await ApiRequest("accounts.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
      }
      return;
    }
    setStateObj(res);
  };
  useEffect(() => {
    if (sortBy === "latest") {
      let records = freeLancers.sort(
        (a, b) => moment(b.joiningdate).unix() - moment(a.joiningdate).unix()
      );
      setFreeLancers(records);
    } else {
      let records = freeLancers.sort(
        (a, b) => moment(a.joiningdate).unix() - moment(b.joiningdate).unix()
      );
      setFreeLancers(records);
    }
  }, [sortBy]);
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);
  useEffect(() => {
    GetCategories();
  }, []);
  const GetCategories = async (e) => {
    let res = await ApiRequest("GetCategory.asp", "GET", null);
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    setCategories(res.items);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (searchtext) setsearchText(searchtext);
    if (_location) setLocation(_location);
    if (sub_category) setselectSubCategories(sub_category);
    GetFreeLancers(searchText || searchtext, sub_category, _location);
  }, [pageno, searchtext, _location, sub_category]);
  const GetFreeLancers = async (_txt, _sub, _loc) => {
    let res = await ApiRequest(
      "search_freelancer.asp",
      "POST",
      JSON.stringify({
        pageno: pageno || 1,
        searchtext: _txt || "",
        sub_category: _sub,
        location: _loc,
      })
    );
    if (res.status === "error") {
      setFreeLancers([]);
      errorToast(res.message);
      return;
    }
    if (sortBy === "latest") {
      let records = res.items.sort(
        (a, b) => moment(b.joiningdate).unix() - moment(a.joiningdate).unix()
      );
      setFreeLancers(records);
    } else {
      let records = res.items.sort(
        (a, b) => moment(a.joiningdate).unix() - moment(b.joiningdate).unix()
      );
      setFreeLancers(records);
    }
  };
  return (
    <>
      <section
        className="banner-1 cover-image sptb-4 sptb-tab"
        style={{ background: `url(${banner}) center center` }}
      >
        <div className="header-text text mb-0">
          <div className="container">
            <div className="text-center text-white ">
              <h1 className="">Welcome to Happie Dealz!</h1>
              <h3>
                Introducing the ultimate global B2B platform for discovering
                Business and connecting with freelance marketers!
              </h3>
            </div>
            <div className="row">
              <div className="col-xl-8 col-lg-12 col-md-12 d-block mx-auto">
                <div className="item-search-tabs">
                  <div className="item-search-menu">
                    <ul className="nav">
                      <li className="">
                        <a
                          href="#"
                          class={
                            selectCategories === "freelancer" ? "active" : ""
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setselectCategories("freelancer");
                          }}
                        >
                          Freelancer
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          class={
                            selectCategories === "provider" ? "active" : ""
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setselectCategories("provider");
                          }}
                        >
                          Provider
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content index-search-select">
                    <div className="tab-pane active">
                      <div className=" search-background bg-transparent">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            navigate(
                              `/${selectCategories === "freelancer"
                                ? "allfreelancers"
                                : "allproviders"
                              }?txt=${searchText || ""}&sub_category=${selectSubCategories || ""
                              }&location=${location || ""}`
                            );
                          }}
                          className="form row g-0"
                        >
                          <div className="form-group col-xl-12 col-lg-12  col-md-12 mb-0 location">
                            <div className="row g-0 br-0">
                              <div className="form-group  col-xl-3 col-lg-3 col-md-12 mb-0 bg-white ">
                                <select
                                  type="text"
                                  className="form-control border-start-0"
                                  id="employe-text"
                                  value={selectSubCategories}
                                  onChange={(e) =>
                                    setselectSubCategories(e.target.value)
                                  }
                                >
                                  <option value={""}>-- Category --</option>
                                  <option value={"company"}>Company</option>
                                  <option value={"individual"}>
                                    Individual
                                  </option>
                                </select>
                                <span>
                                  <i class="fa fa-caret-down location-gps me-1"></i>
                                </span>
                              </div>
                              <div className="form-group  col-xl-3 col-lg-3 col-md-12 mb-0 bg-white ">
                                <input
                                  type="text"
                                  className="form-control border-start-0"
                                  id="employe-text"
                                  placeholder="Enter location"
                                  value={location}
                                  onChange={(e) => setLocation(e.target.value)}
                                />
                                <span>
                                  <i class="fa fa-map-marker location-gps me-1"></i>
                                </span>
                              </div>
                              <div className="form-group  col-xl-4 col-lg-3 col-md-12 mb-0 bg-white ">
                                <input
                                  type="text"
                                  className="form-control border-start-0"
                                  id="employe-text"
                                  placeholder="Type your industry..."
                                  value={searchText}
                                  onChange={(e) =>
                                    setsearchText(e.target.value)
                                  }
                                />
                              </div>
                              <div className="col-xl-2 col-lg-3 col-md-12 mb-0">
                                <button
                                  type="submit"
                                  className="btn btn-block btn-primary fs-14"
                                >
                                  <i className="fa fa-search"></i> Search
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb">
        <div class="container">
          <div class="row">
            <div class="col-xl-9 col-lg-8 col-md-12" data-select2-id="16">
              <div class=" mb-lg-0" data-select2-id="15">
                <div class="" data-select2-id="14">
                  <div class="item2-gl " data-select2-id="13">
                    <div class=" mb-0">
                      <div class="">
                        <div
                          class="bg-white p-5 item2-gl-nav d-md-flex"
                          data-select2-id="12"
                        >
                          {/* {freeLancers.length > 0 ? (
                            <h6 class="mb-0 mt-2">
                              Showing {parseFloat(pageno) * 30 - 29} to
                              {parseFloat(pageno) * 30 - (30 - freeLancers.length)} entries
                            </h6>
                          ) : (
                            <h6 class="mb-0 mt-2">Showing 0 entries</h6>
                          )} */}
                          <div class="d-flex  ms-auto">
                            <label class="me-2 mt-1 mb-sm-1">SortBy:</label>
                            <select
                              name="item"
                              class="form-control select-sm w-100 select2"
                              onChange={(e) => setSortBy(e.target.value)}
                              value={sortBy}
                            >
                              <option value="1">Latest</option>
                              <option value="2">Oldest</option>
                              {/* <option value="3">Price:Low-to-High</option>
                              <option value="4">Price:Hight-to-Low</option> */}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-content">
                      <div class="tab-pane active" id="tab-12">
                        <div class="row">
                          {freeLancers.length <= 0 && (
                            <div className="col-lg-12 col-md-12 col-xl-12">
                              <div className="card overflow-hidden">
                                <div class="text-dark text-center">
                                  <div class="iteam-all-icon">
                                    <img
                                      src={emptycart}
                                      class="imag-service"
                                      alt="No records"
                                      style={{ maxHeight: 200 }}
                                    />
                                  </div>
                                  <div class="item-all-text mt-5">
                                    <h5 class="text-body font-weight-bold">
                                      No Records Found
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {freeLancers.map((item) => {
                            return (
                              <div
                                className="col-lg-6 col-md-12 col-xl-4"
                                key={item.memberid}
                              >
                                <IndividualGrid item={item} />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div class="center-block text-center">
                    <ul class="pagination mb-5">
                      <li
                        class={`page-item page-prev ${pageno > 1 ? "" : "disabled"
                          }`}
                        onClick={() => {
                          if (pageno > 1) {
                            // setpageno(pageno - 1);
                            navigate(
                              `/${selectCategories === "freelancer"
                                ? "allfreelancers"
                                : "allproviders"
                              }?txt=${searchText || ""}&sub_category=${selectSubCategories || ""
                              }&location=${location || ""}&pageno=${parseFloat(pageno) - 1}`
                            );
                          }
                        }}
                      >
                        <label class="page-link">Prev</label>
                      </li>

                      <li
                        class={`page-item page-prev ${freeLancers.length >= 30 ? "" : "disabled"
                          }`}
                        onClick={() => {
                          if (freeLancers.length >= 30) {
                            // setpageno(pageno + 1);
                            navigate(
                              `/${selectCategories === "freelancer"
                                ? "allfreelancers"
                                : "allproviders"
                              }?txt=${searchText || ""}&sub_category=${selectSubCategories || ""
                              }&location=${location || ""}&pageno=${parseFloat(pageno) + 1}`
                            );
                          }
                        }}
                      >
                        <label class="page-link">Next</label>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Categories</h3>
                </div>
                <div class="card-body">
                  <div
                    class="closed"
                    id="container"
                    style={{
                      height: "250px",
                      overflow: "hidden",
                      transition: "0.5s",
                    }}
                  >
                    <div class="filter-product-checkboxs">
                      {categories.map((item) => {
                        return (
                          <label class="custom-control form-radio mb-3">
                            <input
                              type="radio"
                              class="custom-control-input"
                              name="checkbox1"
                              checked={category === item.Category}
                              value={item.Category}
                              id={item.Category}
                              onChange={(e) => {
                                setCategory(e.target.value);
                              }}
                            />
                            <span class="custom-control-label">
                              <label
                                htmlFor={item.Category}
                                class="text-dark mb-1"
                              >
                                {item.Category}
                              </label>
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {/* <div class="card-header border-top">
                  <h3 class="card-title">Price Range</h3>
                </div>
                <RangeSlider
                  min={minPrice}
                  max={maxPrice}
                  onChange={(min, max) => {
                    setMinPrice(min);
                    maxPrice(max);
                  }}
                /> */}
                <div class="card-header border-top">
                  <h3 class="card-title">Condition</h3>
                </div>
                <div class="card-body">
                  <div class="filter-product-checkboxs">
                    <label class="custom-control form-checkbox mb-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        name="checkbox1"
                        value="option1"
                      />
                      <span class="custom-control-label"> New </span>
                    </label>
                    <label class="custom-control form-checkbox mb-0">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        name="checkbox2"
                        value="option2"
                      />
                      <span class="custom-control-label"> Used </span>
                    </label>
                  </div>
                </div>
                <div class="card-header border-top">
                  <h3 class="card-title">User Type</h3>
                </div>
                <div class="card-body">
                  <div class="filter-product-checkboxs">
                    <label class="custom-control form-checkbox mb-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        name="checkbox1"
                        value="option1"
                      />
                      <span class="custom-control-label"> Individual </span>
                    </label>
                    <label class="custom-control form-checkbox mb-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        name="checkbox2"
                        value="option2"
                      />
                      <span class="custom-control-label"> Company </span>
                    </label>
                  </div>
                </div>
                <div class="card-footer">
                  {stateObj.activestatus === "Active" ? (
                    <label
                      onClick={() =>
                        GetFreeLancers(
                          searchText,
                          selectSubCategories,
                          location
                        )
                      }
                      class="btn btn-secondary btn-block"
                    >
                      Apply Filter
                    </label>
                  ) : (
                    <Link to={"/pricing"} class="btn btn-secondary btn-block">
                      Need to Subscribe
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AllFreelancers;
